import { IROH_SERVICES_API_PREFIX } from "@/api/domain"
import type { Interval, MetricInfo } from "@/metrics"
import type { NodeId, ProjectIdParam } from "@/types"
import { formatDateWithoutMillsecondsAndZ } from "@/util"
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

export type MetricSummaryParams = {
  from: Date // EARLIEST point in time
  to: Date // LATEST point in time
  interval: Interval // interval of time between each data point
  endpointId?: NodeId // scope the summary to one endpoint
}

export type Aggregation = {
  info: MetricInfo
  data: number[]
}

// Define a service using a base URL and expected endpoints
export const metricsApi = createApi({
  reducerPath: "metrics",
  baseQuery: fetchBaseQuery({
    baseUrl: `${IROH_SERVICES_API_PREFIX}metrics`,
    mode: "cors",
    credentials: "include",
  }),
  endpoints: (build) => ({
    metricSummary: build.query<
      Aggregation[],
      ProjectIdParam & MetricSummaryParams
    >({
      query: ({ project_id, from, to, interval, endpointId }) => ({
        url: `${project_id}/summary`,
        method: "GET",
        params: {
          from: formatDateWithoutMillsecondsAndZ(from),
          to: formatDateWithoutMillsecondsAndZ(to),
          bucket: interval,
          ...(endpointId ? { endpoint: endpointId } : {}),
        },
      }),
    }),
  }),
})

export const { useMetricSummaryQuery } = metricsApi
